import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { fragAbout } from '../utils/fragments'
import { mapAbout, mapMetaData } from '../utils/mapper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

import styles from '../styles/site'

import TextGradient from '../components/gradient'
import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Footer from '../components/footer'
import InlineVideo from '../components/video/inline'

const AboutPage = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.about)
  const about = mapAbout(props.data.about)

   

  return (
    <div>
      <MetaData data={metadata} />
      <Banner
        uid="about"
        title={about.title}
        subtitle={about.subtitle}
        background={about.image_bg}
      />
      <Metrics about={about} />
      <Img sizes={about.image.sizes} alt={about.image.alt} />
      <Story about={about} />
      <InlineVideo urls={about.video.urls} poster={about.video.poster} />
      <Links about={about} />
      <Footer policies={props.data.policies.edges}/>
    </div>
  )
}

const Metrics = withStyles(styles)(props => {
  const { classes, about } = props
  return (
    <div className={'aboutA'}>
      <div className={classes.aboutMetrics}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={40} className={classes.aboutMetricsTitle}>
              <Grid item className={classes.title}>
                <Typography variant="display1">
                  <TextGradient
                    text={about.metric_title.text}
                    fromColor="#8645B3"
                    toColor="#89DEF4"
                    direction="left"
                  />
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={0}
              justify="center"
              alignItems="center"
              className={classes.aboutMetricsGrid}
            >
              {about.metrics.map(item => {
                return <Metric item={item} classes={classes} />
              })}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Metric = props => (
  <div className={props.classes.aboutMetric}>
    <Grid item>
      <Typography variant="display2">{props.item.value.text}</Typography>
    </Grid>
    <Grid item>
      <Typography variant="subheading">{props.item.metric.text}</Typography>
    </Grid>
  </div>
)

const Story = withStyles(styles)(props => {
  const { classes, about } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.aboutStory}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={40}>
              <Grid item className={classes.title}>
                <Typography variant="display1">
                  <TextGradient
                    text={about.heading.text}
                    fromColor="#8645B3"
                    toColor="#89DEF4"
                    direction="left"
                  />
                </Typography>
              </Grid>
              <div
                dangerouslySetInnerHTML={{
                  __html: about.content && about.content.html,
                }}
                className={classes.aboutStoryText}
              />
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Links = withStyles(styles)(props => {
  const { classes, about } = props
  let LinkButton = (props, link) => <Link to={link} {...props} />
  return (
    <div className={'servicesA'}>
      <div className={classes.aboutLinks}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={40}>
              <Grid item className={classes.title}>
                <Typography variant="display1">
                  <TextGradient
                    text={about.links_title.text}
                    fromColor="#8645B3"
                    toColor="#89DEF4"
                    direction="left"
                  />
                </Typography>
              </Grid>
            </Grid>
          </div>
          <div className={classes.aboutLinkGroup}>
            {about.links.map(item => (
              <Grid item className={classes.aboutLinkItem}>
                <Link to={`/${item.uid}`}>
                  <Button variant="contained">
                    {item.link.text}
                  </Button>
                </Link>
              </Grid>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(AboutPage)

export const query = graphql`
  query aboutQuery {
    about: prismicCtAbout {
      ...about
    }

    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {
              
              text
            }
            
            
          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.js